import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn } from 'intact-vue-next';
import { addStyle, getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    width = _this$get.width,
    style = _this$get.style,
    center = _this$get.center;
  var k = this.config.k;
  var _style = style;
  if (width) {
    _style = addStyle(style, {
      width: width
    });
  }
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-card-column"] = true, _classNameObj[k + "-fluid"] = !width, _classNameObj[k + "-center"] = center, _classNameObj[className] = className, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj),
    'style': _style
  }, getRestProps(this)), children);
}
;